import styled from '@emotion/styled';
import type { ObjectId } from '@racemap/sdk/schema/base';
import { TRACKER_MESSAGE_HISTORY_RECORD_STATE } from '@racemap/sdk/schema/trackers';
import type { Immutable } from 'immer';
import type { FC } from 'react';
import { DangerButton, PrimaryButton, WarningButton } from 'src/components/BasicComponents/Buttons';
import { useIsAdmin } from '../../../lib/customHooks';
import { useStore } from '../../../store/reducers';
import type { ManagedTrackerMessages } from '../../../store/trackers/trackers_reducers';
import { IconErase, IconRefresh, IconTrash } from '../../Icon';
import {
  TRACKER_MESSAGE_HISTORY_RECORD_STATE_FRONTEND,
  getCurrentMessageStatusCode,
  isMessageClosed,
} from './TrackerMessagesTableHelper';

interface Props {
  trackerMessage: Immutable<ManagedTrackerMessages>;
  trackerId: ObjectId;
}

export const TrackerMessageButtonsBody: FC<Props> = ({ trackerMessage, trackerId }) => {
  const isCreated = trackerMessage.id != null;
  const statusCode = getCurrentMessageStatusCode(trackerMessage);

  const { revokeTrackerMessage, clearTrackerMessage, removeTrackerMessage } = useStore(
    (s) => s.trackers.actions,
  );

  const isAdmin = useIsAdmin();

  if (!isCreated) return <></>;
  return (
    <ButtonGroup style={{ display: 'flex', justifyContent: 'center' }}>
      {statusCode === TRACKER_MESSAGE_HISTORY_RECORD_STATE_FRONTEND.PENDING &&
        !isMessageClosed(trackerMessage) && (
          <PrimaryButton
            size="small"
            icon={<IconRefresh flip="horizontal" fixedWidth />}
            onClick={() => revokeTrackerMessage(trackerId, trackerMessage.id)}
          >
            Revoke
          </PrimaryButton>
        )}
      {statusCode === TRACKER_MESSAGE_HISTORY_RECORD_STATE.ERROR && (
        <WarningButton
          size="small"
          icon={<IconErase fixedWidth />}
          onClick={() => clearTrackerMessage(trackerId, trackerMessage.id)}
        >
          Clear
        </WarningButton>
      )}
      {isAdmin &&
        statusCode !==
          (TRACKER_MESSAGE_HISTORY_RECORD_STATE.COMPLETE ||
            TRACKER_MESSAGE_HISTORY_RECORD_STATE.DELIVERED ||
            TRACKER_MESSAGE_HISTORY_RECORD_STATE_FRONTEND.PENDING) && (
          <DangerButton
            size="small"
            icon={<IconTrash fixedWidth />}
            onClick={() => removeTrackerMessage(trackerId, trackerMessage.id)}
          >
            Delete
          </DangerButton>
        )}
    </ButtonGroup>
  );
};

const ButtonGroup = styled.div`
  .btn:not(:last-of-type) {
    margin-right: 5px;
  }
`;
